'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _languageHandler = require('../languageHandler');

var _AutocompleteProvider2 = require('./AutocompleteProvider');

var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);

require('whatwg-fetch');

var _Components = require('./Components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DDG_REGEX = /\/ddg\s+(.+)$/g; /*
                                  Copyright 2016 Aviral Dasgupta
                                  Copyright 2017 Vector Creations Ltd
                                  Copyright 2017, 2018 New Vector Ltd
                                  
                                  Licensed under the Apache License, Version 2.0 (the "License");
                                  you may not use this file except in compliance with the License.
                                  You may obtain a copy of the License at
                                  
                                      http://www.apache.org/licenses/LICENSE-2.0
                                  
                                  Unless required by applicable law or agreed to in writing, software
                                  distributed under the License is distributed on an "AS IS" BASIS,
                                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                  See the License for the specific language governing permissions and
                                  limitations under the License.
                                  */

var REFERRER = 'vector';

var DuckDuckGoProvider = function (_AutocompleteProvider) {
    (0, _inherits3.default)(DuckDuckGoProvider, _AutocompleteProvider);

    function DuckDuckGoProvider() {
        (0, _classCallCheck3.default)(this, DuckDuckGoProvider);
        return (0, _possibleConstructorReturn3.default)(this, (DuckDuckGoProvider.__proto__ || (0, _getPrototypeOf2.default)(DuckDuckGoProvider)).call(this, DDG_REGEX));
    }

    (0, _createClass3.default)(DuckDuckGoProvider, [{
        key: 'getCompletions',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(query, selection) {
                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var _getCurrentCommand, command, range, response, json, results;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _getCurrentCommand = this.getCurrentCommand(query, selection), command = _getCurrentCommand.command, range = _getCurrentCommand.range;

                                if (!(!query || !command)) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return', []);

                            case 3:
                                _context.next = 5;
                                return (0, _bluebird.resolve)(fetch(DuckDuckGoProvider.getQueryUri(command[1]), {
                                    method: 'GET'
                                }));

                            case 5:
                                response = _context.sent;
                                _context.next = 8;
                                return (0, _bluebird.resolve)(response.json());

                            case 8:
                                json = _context.sent;
                                results = json.Results.map(function (result) {
                                    return {
                                        completion: result.Text,
                                        component: _react2.default.createElement(_Components.TextualCompletion, {
                                            title: result.Text,
                                            description: result.Result }),
                                        range: range
                                    };
                                });

                                if (json.Answer) {
                                    results.unshift({
                                        completion: json.Answer,
                                        component: _react2.default.createElement(_Components.TextualCompletion, {
                                            title: json.Answer,
                                            description: json.AnswerType }),
                                        range: range
                                    });
                                }
                                if (json.RelatedTopics && json.RelatedTopics.length > 0) {
                                    results.unshift({
                                        completion: json.RelatedTopics[0].Text,
                                        component: _react2.default.createElement(_Components.TextualCompletion, {
                                            title: json.RelatedTopics[0].Text }),
                                        range: range
                                    });
                                }
                                if (json.AbstractText) {
                                    results.unshift({
                                        completion: json.AbstractText,
                                        component: _react2.default.createElement(_Components.TextualCompletion, {
                                            title: json.AbstractText }),
                                        range: range
                                    });
                                }
                                return _context.abrupt('return', results);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getCompletions(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return getCompletions;
        }()
    }, {
        key: 'getName',
        value: function getName() {
            return '🔍 ' + (0, _languageHandler._t)('Results from DuckDuckGo');
        }
    }, {
        key: 'renderCompletions',
        value: function renderCompletions(completions) {
            return _react2.default.createElement(
                'div',
                { className: 'mx_Autocomplete_Completion_container_block' },
                completions
            );
        }
    }], [{
        key: 'getQueryUri',
        value: function getQueryUri(query) {
            return 'https://api.duckduckgo.com/?q=' + encodeURIComponent(query) + ('&format=json&no_redirect=1&no_html=1&t=' + encodeURIComponent(REFERRER));
        }
    }]);
    return DuckDuckGoProvider;
}(_AutocompleteProvider3.default);

exports.default = DuckDuckGoProvider;
module.exports = exports['default'];
//# sourceMappingURL=DuckDuckGoProvider.js.map